<div>
	<div class="step-title">Agency Profile</div>
	<!-- <div class="info-line">
		<div>Admin</div>
		<input name="admin-email" type="email" [(ngModel)]="adminEmail" placeholder="Admin Email" required/>
	</div> -->
	<div class="init-config">
		<div class="same-line">
			<div class="line-first-part">Name</div>
			<input name="short-name" type="text" [(ngModel)]="info.shortName" (ngModelChange)="onChange()" placeholder="Agency Name" required />	
		</div>
		<div class="same-line">
			<div class="line-first-part">Description</div>
			<input name="long-name" type="text" [(ngModel)]="info.longName" (ngModelChange)="onChange()" placeholder="Description" />		
		</div>
		<div class="same-line">
			<div class="same-line">
				<div class="line-first-part">Boundary:</div>
				<div class="line-second-part">
					<input disabled type="text" name="bdryName" [(ngModel)]="info.bdryName">
				</div>
			</div>
			<div class="same-line">
				<div style="margin-left: 20px;">Category:</div>
				<div class="line-second-part">
					<div *ngFor="let bdryCate of givBdryCateList" class="same-line">
						<input disabled type="radio" name="bdryType" [value]="bdryCate.prop" [(ngModel)]="info.bdryCate" (ngModelChange)="onChange()">
						<div>{{bdryCate.name}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="same-line">
			<div class="line-first-part">Home County:</div>
			<div class="line-second-part">
				<select required name="county" [(ngModel)]="info.county" (ngModelChange)="onSelectCounty()" style="width:50%">
					<option *ngFor="let ct of countyList" [ngValue]="ct">{{ct.name}}</option>
				</select>
			</div>
		</div>
		<!-- <div class="same-line">
			<div class="line-first-part">Collaboration Group Members:</div>
			<div class="line-second-part">
				<div class="neighboring-counties">
					<div *ngFor="let ct of countyList; let idx = index;" class="same-line">
						<input [disabled]="ct===info.county" type="checkbox" name="county{{idx}}" [(ngModel)]="ct.isNeighbor" (ngModelChange)="onChangeNeighborCounty()">
						<div>{{ct.name}}</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="same-line">
			<div class="line-first-part">Discrepancy Agency Id:</div>
			<div class="line-second-part">
				<input required type="text" name="givDomain" style="width:100%" [(ngModel)]="info.discrepancyAgencyId" (ngModelChange)="onChange()">
			</div>
		</div>
		<div class="same-line" style="align-items: start;">
			<div class="line-first-part">NGUID Pattern:</div>
			<div>
				<app-feat-config-nguid [discrepancyAgencyId]="info.discrepancyAgencyId" [nguidPattern]="info.nguidPattern" (changePattern)="onPatternChange($event)"></app-feat-config-nguid>
				<!-- <div class="same-line" title="e.g. urn:emergency:uri:&#123;00006FF0-4486-4641-825E-A9446C2EB8BX&#125;:{{info.discrepancyAgencyId ? info.discrepancyAgencyId : 'state.gov'}}">
					<input name="givNguidPattern" type="radio" [value]="false" [(ngModel)]="info.nguidPattern.layerType" (ngModelChange)="onChange()">
					<div>
						Pattern 1
					</div>
					<div>urn:emergency:uri:{{'&lt;Global ID&gt; : &lt;Discrepancy Agency ID&gt;'}}</div>
				</div>

				<div class="same-line" style="margin-top: 8px;" title="e.g. urn:emergency:uri:SSAP:&#123;00006FF0-4486-4641-825E-A9446C2EB8BX&#125;:{{info.discrepancyAgencyId ? info.discrepancyAgencyId : 'state.gov'}}">
					<input disabled name="givNguidPattern" type="radio" [value]="true" [(ngModel)]="info.nguidPattern.layerType" (ngModelChange)="onChange()">
					<div>
						Pattern 2
					</div>
					<div>urn:emergency:uri:{{'&lt;Layer Type&gt; : &lt;Global ID&gt; : &lt;Discrepancy Agency ID&gt;'}}</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="footer-line">
		<button class="button-general" [disabled]="isApplying||!hasChanged||!info.discrepancyAgencyId" (click)="apply()">Apply</button>
	</div>
</div>